import React, { useState, useEffect } from 'react';
import { Settings, Plus, Save, Loader2, ToggleLeft, ToggleRight, Edit2, Calendar, AlertCircle } from 'lucide-react';

const DocumentManager = () => {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newDoc, setNewDoc] = useState({ name: '', is_mandatory: false });
  
  // --- STATE BARU UNTUK DEADLINE SATLAK ---
  const [deadline, setDeadline] = useState('');
  const [isSavingDeadline, setIsSavingDeadline] = useState(false);
  const [deadlineMessage, setDeadlineMessage] = useState({ type: '', text: '' });
const [savedDeadline, setSavedDeadline] = useState(null); // <--- TAMBAHKAN INI

  const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  useEffect(() => {
    fetchDocs();
    fetchDeadline(); // Panggil fetch deadline saat halaman dimuat
  }, []);

  // --- FUNGSI FETCH DEADLINE ---
  const fetchDeadline = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${BASE_URL}/api/settings/deadline`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        if (data.deadline) {
          setDeadline(data.deadline); // Mengisi kotak form input
          setSavedDeadline(data.deadline); // <--- TAMBAHKAN INI UNTUK TEKS TAMPILAN
        }
      }
    } catch (err) {
      console.error("Gagal load deadline", err);
    }
  };

  // --- FUNGSI SIMPAN DEADLINE ---
 const handleSaveDeadline = async () => {
    if (!deadline) {
      setDeadlineMessage({ type: 'error', text: 'Tanggal tidak boleh kosong!' });
      return;
    }

    setIsSavingDeadline(true);
    setDeadlineMessage({ type: '', text: '' });

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${BASE_URL}/api/admin/settings/deadline`, {
        method: 'POST',
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ deadline_date: deadline })
      });

    if (res.ok) {
        setSavedDeadline(deadline); // <--- TAMBAHKAN INI AGAR TEKS LANGSUNG BERUBAH SAAT DISIMPAN
        setDeadlineMessage({ type: 'success', text: 'Jadwal berhasil diperbarui!' });
        setTimeout(() => setDeadlineMessage({ type: '', text: '' }), 3000);
      } else {
        throw new Error("Gagal menyimpan data");
      }
    } catch (err) {
      setDeadlineMessage({ type: 'error', text: 'Terjadi kesalahan pada server.' });
    } finally {
      setIsSavingDeadline(false);
    }
  };

  const fetchDocs = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`${BASE_URL}/api/document-types`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      setDocs(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (id, field, value) => {
    // Optimistic Update (Ubah UI dulu biar cepat)
    const updatedDocs = docs.map(d => d.id === id ? { ...d, [field]: value } : d);
    setDocs(updatedDocs);

    const docToUpdate = updatedDocs.find(d => d.id === id);
    const token = localStorage.getItem('token');

    try {
      // Perbaikan: Gunakan BASE_URL agar dinamis
      await fetch(`${BASE_URL}/api/admin/documents/${id}`, {
        method: 'PUT',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        },
        body: JSON.stringify(docToUpdate)
      });
    } catch (err) {
      alert("Gagal update server");
      fetchDocs(); // Revert jika gagal
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    if(!newDoc.name) return;
    
    const token = localStorage.getItem('token');
    try {
      // Perbaikan: Gunakan BASE_URL agar dinamis
      await fetch(`${BASE_URL}/api/admin/documents`, {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        },
        body: JSON.stringify(newDoc)
      });
      setNewDoc({ name: '', is_mandatory: false });
      fetchDocs();
      alert("Dokumen berhasil ditambahkan");
    } catch (err) {
      alert("Gagal menambah dokumen");
    }
  };

  return (
    <div className="max-w-5xl mx-auto p-4 md:p-8 animate-fade-in-up">
      <div className="mb-8 border-b border-slate-200 pb-4">
        <h1 className="text-3xl font-serif text-slate-900 flex items-center gap-3">
            <Settings className="text-amber-600"/> Manajemen Sistem
        </h1>
        <p className="text-slate-500 mt-1">Atur jadwal verifikasi dan jenis dokumen yang wajib diupload oleh Guru.</p>
      </div>

      {/* ==================================================== */}
      {/* 1. KARTU PENGATURAN JADWAL (DEADLINE SATLAK) */}
      {/* ==================================================== */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden mb-8">
        <div className="bg-slate-50 border-b border-slate-200 p-4 md:px-6 flex items-center gap-3">
          <div className="bg-blue-100 text-blue-600 p-2 rounded-lg"><Calendar size={20} /></div>
          <div>
            <h2 className="font-bold text-slate-800">Pengaturan Jadwal Verifikasi Satlak</h2>
            <p className="text-xs text-slate-500 mt-0.5">Tentukan batas akhir (cut-off) bagi Satlak untuk melakukan verifikasi PAK.</p>
          </div>
        </div>
        
        <div className="p-4 md:p-6 flex flex-col gap-5">
          {/* TAMPILAN TEKS JADWAL SAAT INI */}
          <div className="bg-slate-50 border border-slate-200 p-4 rounded-lg flex flex-col sm:flex-row sm:items-center justify-between gap-3">
            <div>
              <p className="text-sm font-bold text-slate-500 uppercase tracking-wider mb-1">Jadwal Tersimpan Saat Ini</p>
              {savedDeadline ? (
                <p className="text-xl font-bold text-blue-700">
                  {new Date(savedDeadline).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}
                </p>
              ) : (
                <p className="text-lg font-medium text-slate-400 italic">Belum ada jadwal yang diset</p>
              )}
            </div>
            {savedDeadline && (
              <div className="px-3 py-1 bg-green-100 text-green-700 text-xs font-bold rounded-full border border-green-200 w-max">
                Status: Aktif
              </div>
            )}
          </div>

          {/* FORM UPDATE JADWAL */}
          <div className="flex flex-col md:flex-row items-start md:items-end gap-4 mt-2">
            <div className="flex-1 w-full">
              <label className="block text-sm font-medium text-slate-700 mb-2">
                Ubah Tanggal Penutupan Baru (Pukul 23:59)
              </label>
              <input 
                type="date" 
                value={deadline}
                onChange={(e) => setDeadline(e.target.value)}
                className="w-full md:max-w-xs px-4 py-2 border border-slate-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all font-medium text-slate-700"
              />
            </div>

            <div className="w-full md:w-auto flex flex-col md:flex-row items-center gap-3">
              {deadlineMessage.text && (
                <span className={`text-sm font-medium px-3 py-1.5 rounded-md w-full md:w-auto text-center ${deadlineMessage.type === 'success' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
                  {deadlineMessage.text}
                </span>
              )}
              
              <button 
                onClick={handleSaveDeadline}
                disabled={isSavingDeadline}
                className="w-full md:w-auto px-6 py-2.5 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-colors shadow-sm disabled:opacity-70 flex items-center justify-center gap-2"
              >
                {isSavingDeadline ? <Loader2 size={18} className="animate-spin" /> : <Save size={18} />}
                {isSavingDeadline ? 'Menyimpan...' : 'Simpan Jadwal'}
              </button>
            </div>
          </div>
        </div>

        <div className="bg-amber-50 px-6 py-3 border-t border-amber-100 flex items-start gap-2 text-sm text-amber-800">
          <AlertCircle size={16} className="shrink-0 mt-0.5" />
          <p><strong>Penting:</strong> Setelah tanggal ini terlewati, Satlak hanya bisa melihat data (Read-Only) dan tidak bisa menyetujui/menolak usulan. Akses Admin tetap penuh tanpa batas waktu.</p>
        </div>
      </div>

      {/* ==================================================== */}
      {/* 2. KARTU TAMBAH DOKUMEN BARU */}
      {/* ==================================================== */}
      <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm mb-8">
        <h3 className="font-bold text-slate-800 mb-4">Tambah Jenis Dokumen Baru</h3>
        <form onSubmit={handleAdd} className="flex flex-col md:flex-row gap-4 items-end">
            <div className="flex-1 w-full">
                <label className="text-xs font-bold text-slate-500 uppercase">Nama Dokumen</label>
                <input 
                    type="text" 
                    value={newDoc.name}
                    onChange={(e) => setNewDoc({...newDoc, name: e.target.value})}
                    className="w-full mt-1 p-3 bg-slate-50 border border-slate-200 rounded-lg outline-none focus:border-amber-600"
                    placeholder="Contoh: Sertifikat Seminar"
                />
            </div>
            <div className="flex items-center gap-2 pb-3">
                <button 
                    type="button"
                    onClick={() => setNewDoc({...newDoc, is_mandatory: !newDoc.is_mandatory})}
                    className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-bold transition-all ${newDoc.is_mandatory ? 'bg-red-100 text-red-700' : 'bg-slate-100 text-slate-500'}`}
                >
                    {newDoc.is_mandatory ? "Sifat: WAJIB" : "Sifat: OPSIONAL"}
                </button>
            </div>
            <button type="submit" className="bg-slate-900 text-white px-6 py-3 rounded-lg font-bold hover:bg-slate-800 flex items-center gap-2">
                <Plus size={18} /> Tambah
            </button>
        </form>
      </div>

      {/* ==================================================== */}
      {/* 3. TABEL LIST DOKUMEN */}
      {/* ==================================================== */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
        <table className="w-full text-left text-sm">
            <thead className="bg-slate-900 text-white">
                <tr>
                    <th className="px-6 py-4 font-bold uppercase text-xs">Nama Dokumen</th>
                    <th className="px-6 py-4 font-bold uppercase text-xs text-center">Wajib (Mandatory)</th>
                    <th className="px-6 py-4 font-bold uppercase text-xs text-center">Aktif (Tampil)</th>
                </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
                {docs.map((doc) => (
                    <tr key={doc.id} className="hover:bg-slate-50">
                        <td className="px-6 py-4 font-bold text-slate-800">
                            {doc.name}
                        </td>
                        <td className="px-6 py-4 text-center">
                            <button 
                                onClick={() => handleUpdate(doc.id, 'is_mandatory', !doc.is_mandatory)}
                                className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold cursor-pointer transition-all ${
                                    doc.is_mandatory 
                                    ? 'bg-red-100 text-red-700 border border-red-200' 
                                    : 'bg-slate-100 text-slate-400 border border-slate-200'
                                }`}
                            >
                                {doc.is_mandatory ? "YA, WAJIB" : "TIDAK"}
                            </button>
                        </td>
                        <td className="px-6 py-4 text-center">
                             <button 
                                onClick={() => handleUpdate(doc.id, 'is_active', !doc.is_active)}
                                className="text-slate-600 hover:text-amber-600"
                            >
                                {doc.is_active 
                                    ? <ToggleRight size={32} className="text-emerald-500"/> 
                                    : <ToggleLeft size={32} className="text-slate-300"/>
                                }
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
      </div>
    </div>
  );
};

export default DocumentManager;